// extracted by mini-css-extract-plugin
export default {"loading":"jJkeXSGSor0WxhQZ0Ga8","placeHolderShimmer":"Nf1DEasUG3TYpyPjp3tY"};